const lxConfig = {
  index_pv: 'c_fsp_dcep_j4pmca31',
  lottery_modal_mv: 'b_fsp_dcep_q7gqko9n_mv',
  lottery_modal_award_guide_btn_mc: 'b_fsp_dcep_56m8jvtj_mc',
  lottery_modal_accessory_guide_btn_mc: 'b_fsp_dcep_5ym825gz_mc',
  lottery_modal_receive_btn_mc: 'b_fsp_dcep_d515qssu_mc',
  lottery_modal_share_btn_mc: 'b_fsp_dcep_cvd3q717_mc',
  share_modal_mv: 'b_fsp_dcep_5oguan15_mv',
  share_modal_btn_mc: 'b_fsp_dcep_dqmaczsx_mc',
  animation_pv: 'c_fsp_dcep_q0ecxbr1',
  jump_animation_mc: 'b_fsp_dcep_7gmi82fp_mc',
  nav_share_btn_mc: 'b_fsp_dcep_uzy3yha9_mc',
  lottery_index_btn_mc: 'b_fsp_dcep_egs4hrho_mc',
  play_music_btn_mc: 'b_fsp_dcep_jj55p2aq_mc',
  activity_guide_btn_mc: 'b_fsp_dcep_gd3py49c_mc',
  activity_ruler_btn_mc: 'b_fsp_dcep_zqnd0bss_mc',
  hard_wallet_btn_mc: 'b_fsp_dcep_ycwh2ut7_mc',
  check_envelop_btn_mc: 'b_fsp_dcep_vx3z8wgh_mc',
  one_yuan_purchase_btn_mc: 'b_fsp_dcep_w0t93drx_mc',
  to_wear_btn_mc: 'b_fsp_dcep_sac6esnh_mc',
  check_coupon_btn_mc: 'b_fsp_dcep_4oboe2mf_mc',
  set_avator_modal_mv: 'b_fsp_dcep_402gwrgx_mv',
  set_avatar_btn_mc: 'b_fsp_dcep_pbbu5opb_mc',
  bind_wallet_modal_mv: 'b_fsp_dcep_kvs9k9p7_mv',
  bind_wallet_guide_btn_mc: 'b_fsp_dcep_1e1zo0bo_mc',
  lottery_fail_pv: 'c_fsp_dcep_b81c80cp',
  lottery_fail_btn_mv: 'b_fsp_dcep_ioykqfax_mv',
  lottery_fail_btn_mc: 'b_fsp_dcep_ioykqfax_mc'
};

export { lxConfig };
